import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { ScreenSizeContext } from '@wix/da-hooks/pkg/useMeasureElement/ScreenSizeContext';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { default as Grid } from './Grid';
const MeasuredGrid = (_param)=>{
    var { cookieType, defaultSize, containerClassName } = _param, gridProps = _object_without_properties(_param, [
        "cookieType",
        "defaultSize",
        "containerClassName"
    ]);
    const { width: screenWidth } = useContext(ScreenSizeContext);
    const { ref, dimensions: measuredContainer } = useMeasureElementCookie(cookieType, {
        cookieDim: 'width',
        defaultSize
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: containerClassName,
        ref: ref
    }, /*#__PURE__*/ React.createElement(Grid, _object_spread_props(_object_spread({}, gridProps), {
        screenWidth: screenWidth,
        containerWidth: measuredContainer === null || measuredContainer === void 0 ? void 0 : measuredContainer.width
    }))));
};
MeasuredGrid.displayName = 'MeasuredGrid';
export default MeasuredGrid;

//# sourceMappingURL=MeasuredGrid.js.map